const MOCK_UPLOADS = {
  total_pages: 1,
  uploads: [
    {
      id: 322,
      company_id: 215,
      chatbot_id: 213,
      data_source_id: 1,
      data_source_name: "URL",
      source_name: "https://nuggmd.com",
      source_url: null,
      chars_count: 14450,
      is_live: true,
      created_at: "2025-07-07T16:07:44.342928",
    },
    {
      id: 321,
      company_id: 215,
      chatbot_id: 213,
      data_source_id: 1,
      data_source_name: "URL",
      source_name: "https://nuggmd.com",
      source_url: null,
      chars_count: 14450,
      is_live: true,
      created_at: "2025-07-07T16:07:39.693862",
    },
    {
      id: 320,
      company_id: 215,
      chatbot_id: 213,
      data_source_id: 1,
      data_source_name: "URL",
      source_name: "https://nuggmd.com",
      source_url: null,
      chars_count: 14450,
      is_live: true,
      created_at: "2025-07-07T16:07:36.002458",
    },
    {
      id: 319,
      company_id: 215,
      chatbot_id: 213,
      data_source_id: 1,
      data_source_name: "URL",
      source_name: "https://nuggmd.com",
      source_url: null,
      chars_count: 14450,
      is_live: true,
      created_at: "2025-07-07T16:07:04.290215",
    },
  ],
};

export default MOCK_UPLOADS;
